import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';

// Assets
import {ReactComponent as ExportIcon} from 'assets/img/export.svg'
import CustomButton from "../../CustomButton";
import Popup from "../Mobile/Popup";
import {FormattedMessage} from "react-intl";
import {WMSContext} from "../../../views/wms/context/WMSContext";
import {BarCodeScannerContext} from "../../../contexts/barCodeScannerContext";
import {launchOmniScan} from "../../../api/wms/omiScan";
import {sortingMassTransfer} from "../../../api/wms/wmsContainers/wmsContainers";
import {ReactComponent as EndMissionIcon} from "assets/img/wms/end_mission.svg";
import {ReactComponent as ErrorIcon} from "assets/img/picto-error-404.svg"
import {ReactComponent as RedWarningIcon} from "assets/img/redWarning.svg"
import {Grid} from "@mui/material";
import Toast from "../Toast";
import RightDrawerDesktop from "../Desktop/RightDrawerDesktop";
import RightDrawer from "../Mobile/RightDrawer";
import ManualMassTransfert from "./components/ManualMassTransfert";
import {WMSOmniScanContextKeys} from "../../../utils/WMSOmniScanContextKeys";


FullTransfer.propTypes = {
    handleIsValid: PropTypes.func.isRequired,
    currentContainer: PropTypes.object.isRequired,
    inSorting: PropTypes.bool.isRequired,
    toContainers: PropTypes.array.isRequired,
    customMargin: PropTypes.string,
    customButtonLabel: PropTypes.node,
    shipments:PropTypes.array,
    shipmentId: PropTypes.array,
    onButtonClick: PropTypes.func
};

function FullTransfer({handleIsValid, currentContainer, shipments = [], inSorting, toContainers, customMargin = null, customButtonLabel = null, onButtonClick = () => {}}) {
    const {currentInventory, currentOrganization, isMobile} = useContext(WMSContext)
    const {scannedString, setEnableScan, resetScannedString} = useContext(BarCodeScannerContext)

    const [openTransferErrorModal, setOpenTransferErrorModal] = useState(false)
    const [errors, setErrors] = useState()
    const [openErrorToastNotFound, setOpenErrorToastNotFound] = useState(false)
    const [openManualChoiceDrawer, setOpenManualChoiceDrawer] = useState(false)
    const [openFullTransferModal, setOpenFullTransferModal] = useState(false)
    const [openWrongContainerScanToast, setOpenWrongContainerScanToast] = useState(false)

    const handleCloseFullTransferModal = (isTransferValid = false) => {
        setOpenFullTransferModal(false)
        if (isTransferValid) {
            handleIsValid(isTransferValid)
        }
    }

    const handleCloseTransferErrorModal = () => {
        setOpenTransferErrorModal(false)
        handleIsValid(true)
    }

    const getFormattedKey = (key) => {
        switch (key) {
            case "not-found":
                return <FormattedMessage id={"wms.sorting.TransferErrorModal.notFoundKey"}/>
            case "wrongInventory":
                return <FormattedMessage id={"wms.sorting.TransferErrorModal.wrongInventoryKey"}/>
            case "wrongType":
                return <FormattedMessage id={"wms.sorting.TransferErrorModal.wrongTypeKey"}/>
            case "alreadyBeingSorted":
                return <FormattedMessage id={"wms.sorting.TransferErrorModal.alreadyBeingSortedKey"}/>
            default:
                return <FormattedMessage id={"list.error"}/>
        }
    }

    const getErrorModalSubtitle = () => {
        const errorKeys = Object.keys(errors)
        return (
            <>
                {errorKeys.map(key => {
                    return <Grid key={key} container direction={"column"}>
                        {getFormattedKey(key)}
                        {errors[key].map(shipment => {
                            return <span key={shipment}>{shipment}</span>
                        })}
                    </Grid>
                })}
            </>
        )
    }

    const handleCloseManualChoiceDrawer = () => {
        setOpenManualChoiceDrawer(false)
        setOpenFullTransferModal(true)
    }

    const handleSort = (toContainerCodebar) => {
        sortingMassTransfer(currentContainer.codebar, toContainerCodebar, currentInventory.id, shipments).then(r => {
            if (0 < Object.keys(r).length) {
                setErrors(r)
                handleCloseFullTransferModal(false)
                setOpenManualChoiceDrawer(false)
                setOpenTransferErrorModal(true)
            } else {
                handleCloseFullTransferModal(true)
                setOpenManualChoiceDrawer(false)
            }
        })
    }

    useEffect(() => {
        if (openFullTransferModal && 0 < scannedString.length && currentInventory && currentContainer) {
            setEnableScan(false)
            launchOmniScan(scannedString, currentInventory.id, {[WMSOmniScanContextKeys.CONTAINER]: toContainers}).then((response) => {
                if (1 === response.length) {
                    const scannedContainer = response[0]

                    if (currentOrganization.containerToShippingMethodMatch) {
                        const shipmentShippingMethodIds = shipments.map((s) => s.shippingMethodId).filter(Boolean)
                        const containerMatchesShippingMethod = !scannedContainer.shippingMethods?.length
                            || scannedContainer.shippingMethods.some((sm) => shipmentShippingMethodIds.includes(sm.id))

                        if (!containerMatchesShippingMethod) {
                            setOpenWrongContainerScanToast(true)
                            return
                        }
                    }

                    sortingMassTransfer(currentContainer.codebar, scannedContainer.codebar, currentInventory.id, shipments).then(r => {
                        if (0 < Object.keys(r).length) {
                            setErrors(r)
                            handleCloseFullTransferModal(false)
                            setOpenTransferErrorModal(true)
                        } else {
                            handleCloseFullTransferModal(true)
                        }

                    })
                } if (0 === response.length) {
                    setOpenErrorToastNotFound(true)
                }
            }).finally(() => {
                setOpenManualChoiceDrawer(false)
                setOpenFullTransferModal(true)
                resetScannedString()
                setEnableScan(true)
            })
        }
    }, [scannedString]);
    return (
        <>
            {openFullTransferModal && (
                <Popup
                    open={openFullTransferModal}
                    onClose={handleCloseFullTransferModal}
                    title={<FormattedMessage id={"wms.sorting.fullTransferModal.title"}/>}
                    subtitle={<FormattedMessage id={"wms.sorting.fullTransferModal.subtitle"}/>}
                    icon={<EndMissionIcon/>}
                    isMobile
                >
                    <CustomButton
                        onClick={() => {
                            setOpenFullTransferModal(false)
                            setOpenManualChoiceDrawer(true)
                        }}
                        style={{
                            marginLeft: customMargin ?? '8px',
                            cursor: 'pointer'
                        }}
                        color={"blue"}
                        fullWidth={inSorting}
                    >
                        <FormattedMessage id={"wms.massTransfer.modal.manualChoiceDrawer.button"} />
                    </CustomButton>
                </Popup>
            )}

            {openTransferErrorModal && (
                <Popup
                    open={openTransferErrorModal}
                    onClose={handleCloseTransferErrorModal}
                    title={<FormattedMessage id={"wms.sorting.TransferErrorModal.title"}/>}
                    subtitle={getErrorModalSubtitle()}
                    icon={<ErrorIcon/>}
                    isMobile
                />
            )}

            {openErrorToastNotFound && (
                <Toast
                    open={openErrorToastNotFound}
                    handleClose={() => {
                        setOpenErrorToastNotFound(false)
                    }}
                    title={<FormattedMessage id={'wms.omniScan.notFound'}/>}
                    icon={<RedWarningIcon/>}
                />
            )}

            {openWrongContainerScanToast && (
                <Toast
                    open={openWrongContainerScanToast}
                    handleClose={() => {
                        setOpenWrongContainerScanToast(false)
                    }}
                    title={<FormattedMessage id={"wms.packing.toast.omniScan.wrongContainer.title"} />}
                    icon={<img style={{height: '20px', width: '20px'}} src={ErrorIcon} alt={"validated-icon"}/>}
                />
            )}

            {openManualChoiceDrawer && !isMobile && (
                <RightDrawerDesktop
                    open={openManualChoiceDrawer}
                    onClose={handleCloseManualChoiceDrawer}
                    title={<FormattedMessage id={"wms.massTransfer.manualChoiceDrawer.title"}/>}
                    subtitle={<FormattedMessage id={"wms.massTransfer.manualChoiceDrawer.subtitle"}/>}
                    disablePortal
                >
                    <ManualMassTransfert
                        shipments={shipments}
                        toContainers={toContainers}
                        handleSelectedContainer={(containerCodebar) => handleSort(containerCodebar)}
                    />
                </RightDrawerDesktop>
            )}

            {openManualChoiceDrawer && isMobile && (
                <RightDrawer
                    open={openManualChoiceDrawer}
                    handleClose={handleCloseManualChoiceDrawer}
                    headerCenterContent={
                    <b>
                        <FormattedMessage id={"wms.massTransfer.manualChoiceDrawer.subtitle"}/>
                    </b>}
                >
                    <ManualMassTransfert
                        shipments={shipments}
                        toContainers={toContainers}
                        handleSelectedContainer={(containerCodebar) => handleSort(containerCodebar)}
                    />
                </RightDrawer>
            )}

            <CustomButton
                onClick={() => {
                    onButtonClick()
                    setOpenFullTransferModal(true)
                }}
                style={{
                    marginLeft: customMargin ?? '8px',
                    cursor: 'pointer'
                }}
                color={"blue"}
                fullWidth={inSorting}
            >
                {customButtonLabel}
                {/* Base ExportIcon is facing upward */}
                <div style={{transform: "rotate(90deg)", marginLeft: customButtonLabel ? "8px" : 0}}>
                    <ExportIcon />
                </div>
            </CustomButton>
        </>
    );
}

export default FullTransfer;
